module.exports = {
      id: "marker-usage",
      viewBox: "0 0 27 36",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#marker-usage",
      toString: function () {
        return this.url;
      }
    }